var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.314941,
    width: 77,
    height: 77,
    rx: 38.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L47.6767 24.0117L42.7541 17.25Z",
    fill: "#0F9D58"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.937 38.0176V52.0213H46.693V38.0176H30.937ZM37.8292 50.0897H32.9087V47.6757H37.8335V50.0897H37.8292ZM37.8292 46.2265H32.9087V43.8125H37.8335V46.2265H37.8292ZM37.8292 42.3632H32.9087V39.9492H37.8335V42.3632H37.8292ZM44.7235 50.0897H39.8008V47.6757H44.7235V50.0897ZM44.7235 46.2265H39.8008V43.8125H44.7235V46.2265ZM44.7235 42.3632H39.8008V39.9492H44.7235V42.3632Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6187 27.9938L54.5733 38.7336V28.8417L43.6187 27.9917V27.9938Z",
    fill: "url(#paint0_linear_1520_5991)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7542 17.25V25.9413C42.7542 27.5435 44.0758 28.8419 45.7095 28.8419H54.5711L42.7563 17.25H42.7542Z",
    fill: "#87CEAC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0101 17.25C24.3851 17.25 23.0569 18.5548 23.0569 20.1485V20.3886C23.0569 18.7949 24.3872 17.4923 26.0122 17.4923H42.7541V17.25H26.0101Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6201 59.5077H26.0101C24.3851 59.5077 23.0569 58.2051 23.0569 56.6113V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V56.6113C54.5732 58.2051 53.2451 59.5077 51.6201 59.5077Z",
    fill: "#263238",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1520_5991",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 17,
    width: 32,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1520_5991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7095 28.8419C44.0758 28.8419 42.7542 27.5456 42.7542 25.9434V26.1856C42.7542 27.7857 44.0758 29.082 45.7095 29.082H54.5711V28.8419H45.7095Z",
    fill: "#263238",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7541 17.25H26.0122C24.3872 17.25 23.0569 18.5548 23.0569 20.1485V56.8515C23.0569 58.4452 24.3872 59.75 26.0122 59.75H51.6179C53.2429 59.75 54.5732 58.4452 54.5732 56.8515V28.8419L42.7541 17.25Z",
    fill: "url(#paint1_radial_1520_5991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1520_5991",
    x1: 591.376,
    y1: 120.217,
    x2: 591.376,
    y2: 1102.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1520_5991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.899 101.249) scale(5081.77 4984.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelCircle);
export default __webpack_public_path__ + "static/media/excelCircle.f1121d661a78c0ff7b765ef59edc1f77.svg";
export { ForwardRef as ReactComponent };